import React, { useState } from "react";
import './SetPassword.css';

const SetPassword = ({ setIsResetting, resetEmail, setResetEmail, handleBackToLogin }) => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleResetSubmit = async (e) => {
        e.preventDefault();

        if (!newPassword || !confirmPassword) {
            setError("Please fill in both new password and confirm password.");
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        setLoading(true);
        setError("");
        setSuccessMessage("");

        try {
            const response = await fetch("http://localhost:5000/reset-password", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email: resetEmail, newPassword, confirmPassword }),
            });

            setLoading(false);

            if (response.ok) {
                const data = await response.json();
                setSuccessMessage(data.message);
                window.location.reload();
            } else {
                const errorData = await response.json();
                setError(errorData.error);
            }
        } catch (error) {
            setLoading(false);
            setError("An error occurred while resetting password. Please try again.");
        }
    };

    return (
        <div className="reset-password-container">
            <form onSubmit={handleResetSubmit} className="reset-password-form">
                <div className="input-group">
                    <label htmlFor="reset-email">Email</label>
                    <input
                        type="email"
                        id="reset-email"
                        value={resetEmail}
                        onChange={(e) => setResetEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                        className="reset-input"
                    />
                </div>

                <div className="input-group">
                    <label htmlFor="new-password">New Password</label>
                    <div className="password-container">
                        <input
                            type={showNewPassword ? "text" : "password"}
                            id="new-password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter new password"
                            required
                            className="reset-input"
                        />
                        <span
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            className="show-password-toggle"
                        >
                            {showNewPassword ? "Hide" : "Show"}
                        </span>
                    </div>
                </div>

                <div className="input-group">
                    <label htmlFor="confirm-password">Confirm Password</label>
                    <div className="password-container">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            id="confirm-password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm new password"
                            required
                            className="reset-input"
                        />
                        <span
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            className="show-password-toggle"
                        >
                            {showConfirmPassword ? "Hide" : "Show"}
                        </span>
                    </div>
                </div>

                {error && <p className="error-message">{error}</p>}
                {successMessage && <p className="success-message">{successMessage}</p>}

                <button type="submit" className="reset-button" disabled={loading}>
                    {loading ? "Processing..." : "Reset Password"}
                </button>
            </form>

            <div className="back-to-login">
                <p onClick={handleBackToLogin} className="reset-link">Back to Login</p>
            </div>
        </div>
    );
};

export default SetPassword;
